/** 产品管理API */
import type { Api } from '@/typings/api';
import type { DictTypeEnum } from '@/enum';
import { download, post, upload } from '../../request';
import type { FlatResponseData } from '~/packages/axios/src';
const prefix = '/base/baseProductInfo';
/**
 * 分页查询产品管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Base.ProductInfo> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询产品管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Base.ProductInfo> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个产品管理
 *
 * @param id 产品管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Base.ProductInfo> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存产品管理
 *
 * @param params 产品管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新产品管理信息
 *
 * @param params 产品管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除产品管理
 *
 * @param id 产品管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除产品管理
 *
 * @param ids 产品管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};
/**
 * 导入
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/import`, file, params);
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params);
};

/**
 * 导出上级分配产品
 *
 * @param params
 * @returns
 */
export const doExportParentProduct = (params: Api.Common.CommonSearchParams, fileName: string) => {
  return download(`${prefix}/export`, params, `${fileName ?? '产品清单'}.xlsx`);
};

/**
 * 导入上级分配产品
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImportParentProduct = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/importParentProduct`, file, params);
};

/**
 * 给下级导入产品清单
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImportProductList = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/importProductList`, file, params);
};

/**
 * 获取客户所有产品指定类型
 *
 * @param params
 * @returns
 */
export const getAllProduct = (params: {
  type?: number;
  dictType: DictTypeEnum;
  filter?: Api.Common.Filter[];
}): Promise<FlatResponseData> => {
  return post(`${prefix}/getAllProduct`, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  doExport,
  getAllProduct
};
